import Vue from 'vue';
import {
  CellGroup,
  Cell,
  Button,
  Field,
  Checkbox,
  List,
  Icon,
  Loading,
  Picker,
  Popup,
  Dialog,
  CollapseItem,
  Collapse,
  PullRefresh,
  Tabs,
  Tab,
  Divider,
  DatetimePicker,
  Uploader,
  Image,
  Switch,
  Stepper,
  Tag,
  CheckboxGroup,
  Area,
  Circle,
  NumberKeyboard,
  NoticeBar,
  Empty,
  Search,
  Form,
} from 'vant';

Vue.use(Form);
Vue.use(Search);
Vue.use(Circle);
Vue.use(Area);
Vue.use(Tag);
Vue.use(CheckboxGroup);
Vue.use(Stepper);
Vue.use(Switch);
Vue.use(Image);
Vue.use(Uploader);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(Button);
Vue.use(Field);
Vue.use(Checkbox);
Vue.use(List);
Vue.use(Icon);
Vue.use(Loading);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(CollapseItem);
Vue.use(Collapse);
Vue.use(PullRefresh);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Divider);
Vue.use(DatetimePicker);
Vue.use(NumberKeyboard);
Vue.use(NoticeBar);
Vue.use(Empty);
